// extracted by mini-css-extract-plugin
module.exports = {"container":"NoDataSection_container__yu9q4","noDataTitle":"NoDataSection_noDataTitle__yDkFW","noDataDesc":"NoDataSection_noDataDesc__GDc8n"};